import { Button } from "@sellar-io/components";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useBuyerRelationshipDelete } from "../../../../hooks/api/v2/buyerRelationship/useBuyerRelationshipDelete";

export const RemoveFromListDialog = ({
  onDismiss,
  active,
  buyerRelationshipId,
  onSubmit,
}: {
  onDismiss: () => void;
  onSubmit?: () => void;
  active: boolean;
  buyerRelationshipId: number;
}) => {
  const deleteBuyerRelationshipMutation =
    useBuyerRelationshipDelete(buyerRelationshipId);

  const onRemove = () => {
    deleteBuyerRelationshipMutation.mutate(undefined, {
      onSuccess: () => {
        onSubmit?.();
        onDismiss();
      },
    });
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Remove from list?"}
      />
      <DialogContent>
        {deleteBuyerRelationshipMutation.isError ? (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(deleteBuyerRelationshipMutation.error)?.response
                ?.data.message ?? "Unknown error"
            }
          />
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button
          loading={deleteBuyerRelationshipMutation.isPending}
          color={"red"}
          onClick={onRemove}
        >
          Remove from list
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
